import React, { useState, memo, useRef, useEffect } from "react";
import Formsy from "formsy-react";
import { withRouter, Link } from "react-router-dom";
import { TextInput } from "../../../Shared/Forms";
import { Row, Col, Button, Spinner, UncontrolledAlert } from "reactstrap";
import { MdFileUpload, MdArrowBack } from "react-icons/md";
import { UploadFile } from "../../../Shared/FileUpLoad";
import { upLoadService } from "../../../Shared/Forms/UploadImageService";
import { ManageAllMealPlansPage } from "../../../../_constants/RouteVariables";
import { toast } from "react-toastify";
const GeneralEditMealPlanForm = memo((props) => {
    const { submitted, submitting, handleSubmit, formError, generalMealPlanDatas, hideMealRoasterForm, showMealRoasterForm, mealImageUrl, cancel, roasterResponseData } = props;
    const editMealPlanFormRef = useRef("generalEditMealPlanForm");
    //form fields....
    const [name, setName] = useState(null);
    const [description, setDescription] = useState(null);
    const [calories, setCalories] = useState(null);
    const [generalImageUrl, setGeneralImageUrl] = useState(null);
   
    const [days, setDays] = useState(null);
    const [temporaryDays, setTemporaryDays] = useState(null);
    const [mealId, setMealId] = useState(null);

    const [imageUploaded, setImageUploaded] = useState(false);
    // validation states
    const [canSubmit, setCanSubmit] = useState(false);
    const [isUpLoading, setIsUpLoading] = useState(false);
    const [uploadingSubmitting, setUploadingSubmitting] = useState(false);

    //image error handling..
    const [imageUploadError, setImageUploadError] = useState(null);

    const cancelUploadedImageUrl = () => {
        cancel();
    };

    const uploadImageToCloud = async (data) => {
        setCanSubmit(false);
        setUploadingSubmitting(true);

        try {
            let response = await upLoadService.submitImage(data);
            if (response && response.imageUrl) {
                setUploadingSubmitting(false);
                setIsUpLoading(false);
                setCanSubmit(true);
                setGeneralImageUrl({ key: "imageUrl", value: response.imageUrl });
                setImageUploaded(true);
            }
        } catch (error) {
            setImageUploadError(error);
            setUploadingSubmitting(false);
            setImageUploaded(false);
        }
    };

    const submitGeneralMealPlan = (e) => {
       
        try {
            if (e) {
                let refineData = { name: e.name, description: e.description, calories: parseFloat(e.calories), durationDays: parseInt(e.durationDays), imageUrl: generalImageUrl ? generalImageUrl.value : mealImageUrl ? mealImageUrl : null };
          
                handleSubmit(refineData);
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (generalMealPlanDatas.mealPlanName !== null) {
            setName(generalMealPlanDatas.mealPlanName);
            setMealId(generalMealPlanDatas.mealPlanId);
            setDescription(generalMealPlanDatas.mealPlanDescription);
            setCalories(generalMealPlanDatas.mealPlanCalorie);
            setDays(generalMealPlanDatas.days);
            setTemporaryDays(generalMealPlanDatas.days);
        }
    }, [generalMealPlanDatas]);

    const enableButton = () => {
        setCanSubmit(true);
    };
    const disableButton = () => {
        setCanSubmit(false);
    };
    useEffect(() => {
        hideMealRoasterForm();
    }, []);

    const handleChangesEditMeal = (e) => {
        if (e.name !== name && e.name !== null) {
            showMealRoasterForm();
        } else if (e.description !== description && e.description !== null) {
            showMealRoasterForm();
        } else if (parseFloat(e.calories) !== parseFloat(calories) && e.calories !== null) {
            showMealRoasterForm();
        } else if (parseFloat(e.durationDays) !== parseFloat(days) && e.durationDays !== null) {
            if (parseFloat(e.durationDays) < parseFloat(temporaryDays)) {
                if (roasterResponseData && roasterResponseData.length > 0) {
                    //show warning toast
                    toast.warn(`You have to remove excess roster days before updating meal plan `, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: false,
                    });

                    hideMealRoasterForm();
                }
            } else {
                showMealRoasterForm();
            }
        }
    };

    const uploadingToCloud = (imageData) => {
        let newImageData = imageData && imageData.substr(22);
        setIsUpLoading(true);
        uploadImageToCloud({ base64Image: newImageData });
    };

    const cancelImageUploadingSetting = () => {
        setImageUploaded(false);
    };

    return (
        <React.Fragment>
            <Link
                to={{
                    pathname: ManageAllMealPlansPage,
                    state: { status: "draft" },
                }}
            >
                <Button type="button" color="primary" className="mb-2">
                    <MdArrowBack />
                    <span>Back</span>
                </Button>
            </Link>
            <Formsy ref={editMealPlanFormRef} onValidSubmit={submitGeneralMealPlan} onValid={enableButton} onInvalid={disableButton} noValidate onChange={handleChangesEditMeal}>
                {formError && !formError.errors ? <UncontrolledAlert color="danger">{formError.message}</UncontrolledAlert> : null}
                {formError && formError.errors ? (
                    <UncontrolledAlert color="danger">
                        {formError.errors.map((error, index) => (
                            <p key={index}>{error.message}</p>
                        ))}
                    </UncontrolledAlert>
                ) : null}
                <Row>
                    <Col sm="5">
                        <TextInput
                            name="name"
                            required
                            title="Name"
                            validations={{
                                minLength: 3,
                                maxLength: 50,
                            }}
                            validationErrors={{
                                minLength: "Minimum of 3 characters allowed",
                                maxLength: "Maximum of 50 characters allowed",
                            }}
                            value={name ? name : null}
                        />
                        <TextInput
                            name="description"
                            required
                            title="Description"
                            validations={{
                                minLength: 5,
                            }}
                            validationErrors={{
                                minLength: "Minimum of 5 characters allowed",
                                maxLength: "Maximum of 50 characters allowed",
                            }}
                            value={description ? description : null}
                        />
                        <TextInput
                            name="calories"
                            required
                            title="Total Calories (Kcals) "
                            validations={{
                                isNumeric: true,
                            }}
                            validationErrors={{
                                isNumeric: "Whole numbers or decimals numbers only allowed",
                            }}
                            value={calories ? calories : null}
                        />
                      
                        {!submitted ? (
                            <Button type="submit" color="primary" disabled={!canSubmit || submitting} className="pp3 mr-1">
                                {submitting ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <span>
                                        {"Update"} <MdFileUpload size={20} />
                                    </span>
                                )}
                            </Button>
                        ) : null}
                    </Col>
                    <Col sm="7">
                        <div style={{ width: "74%" }}>
                            <TextInput
                                name="durationDays"
                                required
                                title="Duration(Day(s))"
                                validations={{
                                    matchRegexp: /^[1-9][0-9]*$/,
                                }}
                                validationErrors={{
                                    matchRegexp: "Whole numbers numbers only allowed",
                                }}
                                value={days ? days : null}
                            />
                        </div>
              
                        <div style={{ paddingTop: "0.5rem" }}>
                            <UploadFile
                                name="imageUrl"
                                type="file"
                                acceptedFormats={"jpg|jpeg|png"}
                                disabled={submitting}
                                value={mealImageUrl || null}
                                maxSize={1048576}
                                imageUrl={mealImageUrl || null}
                                //setImageNull={setImageNull}
                                isUpLoading={isUpLoading}
                                uploadToServer={true}
                                uploadingToCloud={uploadingToCloud}
                                imageUploadError={imageUploadError}
                                cancelUploadedImageUrl={cancelUploadedImageUrl}
                                submitting={uploadingSubmitting}
                                isImageUpLoaded={imageUploaded}
                                cancelImageUploadingSetting={cancelImageUploadingSetting}
                                required
                            />
                        </div>
                    </Col>
                </Row>
            </Formsy>
        </React.Fragment>
    );
});

export default withRouter(GeneralEditMealPlanForm);
